import React, { createContext, useState, useContext, useCallback } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  
  // 移除特定通知
  const removeToast = useCallback((id) => {
    setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  }, []);

  // 添加新的通知
  // CARQ-95：showToast/removeToast 以 useCallback 固定參照。原本每次 render 都是新函式，
  // 頁面若把 showToast 放進 useCallback/useEffect 依賴（如合約範本頁的 load），
  // 提醒出現/消失時就會重新載入整頁 → 畫面閃一次。
  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast = { id, message, type, duration };
    
    setToasts(currentToasts => [...currentToasts, newToast]);
    
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }, [removeToast]);
  
  return (
    <ToastContext.Provider value={{ toasts, showToast, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
};

// 創建一個簡易的 Hook 來使用 Toast Context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
